export default __webpack_public_path__ + "static/media/anniversary-banner-bm.6bf0e3e7.webp";